import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { Grid } from '@material-ui/core';
import { Fields } from './components/GenericField';
import { FieldsNoSpace } from './components/FieldsNoSpace';

const Field = (_ref) => {
  let {
    noJustify
  } = _ref,
      props = _objectWithoutProperties(_ref, ["noJustify"]);

  return noJustify ? /*#__PURE__*/React.createElement(FieldsNoSpace, _extends({}, props, {
    DataTypographyProps: _objectSpread({
      display: 'contents'
    }, props.DataTypographyProps),
    LabelTypographyProps: _objectSpread({
      display: 'contents'
    }, props.LabelTypographyProps)
  })) : /*#__PURE__*/React.createElement(Fields, props);
};

export const FieldBasic = (_ref2) => {
  let {
    label,
    data,
    classes = {},
    gridProps,
    noJustify
  } = _ref2,
      props = _objectWithoutProperties(_ref2, ["label", "data", "classes", "gridProps", "noJustify"]);

  return /*#__PURE__*/React.createElement(Grid, _extends({
    item: true,
    container: true,
    xs: 12
  }, gridProps), /*#__PURE__*/React.createElement(Field, _extends({
    classes: classes,
    label: label,
    noJustify: noJustify,
    data: data
  }, props)));
};